import { callFetch } from './serviceHelpers';

export const getAvailableFilters = () =>
  callFetch(process.env.REACT_APP_DASHBOARD_SERVICE_URL, 'GET', 'v1/elastic/available-filters');
